










import { Component, Vue } from 'vue-property-decorator';
import {Route} from "vue-router";
import {SET_BOOKLETS, SET_LANGUAGE} from "@/store";
import ErrorBooklets from '@/components/views/booklets/ErrorBooklets.vue';
import Loading from '@/components/layout/Loading.vue';
import {SET_LAYOUT_CONFIG} from "@/store/layout_module";
import i18n, {loadLanguageAsync} from "@/i18n";

@Component({
  components: {
    Loading,
    ErrorBooklets
  },
  beforeRouteEnter(to: Route, from: any, next: any) {
    const filter = to.params.filter;
    next((d: BookletsWrapper) => {
      d.fetchData(filter);
    });
  }
})
export default class BookletsWrapper extends Vue {

  private loading: boolean = true;
  private error: boolean = false;

  private fetchData(filter: string) {
    this.loading = true;

    const params = {
      filter
    }

    this.$store.commit('layout/' + SET_LAYOUT_CONFIG, {
      showPageTitle: false
    })

    this.axios.get('/booklets-filter', {
      params
    }).then(response => {

      this.$store.commit(SET_BOOKLETS, response.data.data.promptFiltersBooklets);

      const lang = response.data.data.language === 'lang2' ? 'es' : 'en';

      this.$store.commit(SET_LANGUAGE, lang);

      loadLanguageAsync(lang).then(() => {
        this.$store.commit('layout/' + SET_LAYOUT_CONFIG, {
          showPageTitle: true,
        })

        this.loading = false;
      });



    }).catch((error) => {
      this.loading = false;
      this.error = true;

      this.$store.commit('layout/' + SET_LAYOUT_CONFIG, {
        showPageTitle: false,
      })

    });
  }

}
